import { render, staticRenderFns } from "./indexFeeStatistics.vue?vue&type=template&id=721bcab0&scoped=true"
import script from "./indexFeeStatistics.vue?vue&type=script&lang=js"
export * from "./indexFeeStatistics.vue?vue&type=script&lang=js"
import style0 from "./indexFeeStatistics.vue?vue&type=style&index=0&id=721bcab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721bcab0",
  null
  
)

export default component.exports